import {ApiErrorCodeEnum} from '../enums/api-error-code.enum';

export class TokenAuthenticationError extends Error {
    public constructor(public status?: number, message?: string) {
        super(message);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, TokenAuthenticationError.prototype);
    }
}

export class OrganisationError extends Error {
    private readonly codeEnum: ApiErrorCodeEnum;

    public constructor(message: string, codeEnum: ApiErrorCodeEnum) {
        super(message);
        this.codeEnum = codeEnum;
    }

    public getCodeEnum(): ApiErrorCodeEnum {
        return this.codeEnum;
    }
}

export class OrganisationNotFoundError extends OrganisationError {
    public constructor() {
        super('The organisation does not exist', ApiErrorCodeEnum.OrganisationNotFound);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, OrganisationNotFoundError.prototype);
    }
}

export class ReachedMaximumUsersError extends OrganisationError {
    public constructor() {
        super('The maximum concurrent user count is reached.', ApiErrorCodeEnum.ReachedMaximumUsers);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ReachedMaximumUsersError.prototype);
    }
}

export class OrganisationMemberIsInactiveError extends OrganisationError {
    public constructor() {
        super('The specified organisation member is inactive.', ApiErrorCodeEnum.InactiveOrganisationMember);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, OrganisationMemberIsInactiveError.prototype);
    }
}

export class OrganisationMemberNotFoundError extends OrganisationError {
    public constructor() {
        super('The specified organisation member was not found.', ApiErrorCodeEnum.OrganisationMemberNotFound);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, OrganisationMemberNotFoundError.prototype);
    }
}

export class OrganisationLicenseExpiredError extends OrganisationError {
    public constructor() {
        super('The license of the organisation is expired.', ApiErrorCodeEnum.OrganisationLicenseExpired);

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, OrganisationLicenseExpiredError.prototype);
    }
}

export class AzureLoginFailedError extends Error {
    public constructor() {
        super('Azure login failed');

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, AzureLoginFailedError.prototype);
    }
}
